import * as React from 'react';

function SvgChevronLeft(props) {
  return (
    <svg width={15} height={16} viewBox="0 0 15 16" fill="none" {...props}>
      <path
        d="M10 2L4 8l6 6"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

export default SvgChevronLeft;
